import {downloadFileByUrl} from "@/helpers/downloadHelper";

function escapeCsvCell(value: string | number | null | undefined): string {
  const safeValue = value === null || value === undefined ? '' : `${value}`;
  return `"${safeValue.replace(/"/g, '""')}"`;
}

export function generateCsvContent(headers: string[], rows: Array<Array<string | number | null | undefined>>): string {
  return [headers, ...rows]
    .map((line) => line.map(escapeCsvCell).join(','))
    .join('\n');
}

export function downloadCsv(headers: string[], rows: Array<Array<string | number | null | undefined>>, fileName: string): void {
  const csv = generateCsvContent(headers, rows);
  const csvBlob = new Blob(["\uFEFF" + csv], {type: 'text/csv;charset=utf-8;'});
  const url = URL.createObjectURL(csvBlob);
  downloadFileByUrl(url, fileName);
  URL.revokeObjectURL(url);
}
